var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "conversation-item",
      class: {
        active: _vm.isActive(),
        ghost: _vm.isGhost(),
        unreaded: _vm.getUnreadCount(),
      },
      on: { click: _vm.clickConversation },
    },
    [
      !_vm.isGhost()
        ? _c("div", { staticClass: "minimize-card-detail" }, [
            _c("div", { staticClass: "conversation-contact-avatar" }, [
              _c(
                "div",
                [
                  _c("ContactAvatar", {
                    attrs: { contact: _vm.contact, badge: true, size: "small" },
                  }),
                  _vm._v(" "),
                  _vm.contact.platform === "whatsapp"
                    ? _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                followCursor: true,
                                placement: "bottom-end",
                                delay: [600, 0],
                              },
                              expression:
                                "{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }",
                            },
                          ],
                          staticClass: "channel-name-text",
                          attrs: {
                            content:
                              "Chat Bu Kanalda Başlamıştır " + _vm.channelName,
                          },
                        },
                        [
                          _vm.channelType === "whatsapp-business-api"
                            ? _c("WhatsappBusinessIcon", {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      followCursor: true,
                                      placement: "bottom-end",
                                      delay: [600, 0],
                                    },
                                    expression:
                                      "{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }",
                                  },
                                ],
                                staticStyle: { width: "10px", height: "10px" },
                                attrs: { content: "Web", color: "#59c864" },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.channelType === "whatsapp-v2"
                            ? _c("WhatsappV2", {
                                directives: [
                                  {
                                    name: "tippy",
                                    rawName: "v-tippy",
                                    value: {
                                      followCursor: true,
                                      placement: "bottom-end",
                                      delay: [600, 0],
                                    },
                                    expression:
                                      "{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }",
                                  },
                                ],
                                staticStyle: { width: "10px", height: "10px" },
                                attrs: { content: "Web", color: "#59c864" },
                              })
                            : _vm._e(),
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.channelName.length > 10
                                  ? _vm.channelName.substring(0, 10) + "..."
                                  : _vm.channelName
                              ) +
                              "\n                "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "contact-platform" },
                [
                  _c("PlatformIcon", {
                    attrs: { platform: _vm.channelType, size: 15 },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "contact-detail" }, [
              _c("div", { staticClass: "contact-detail-head" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: {
                          followCursor: true,
                          placement: "bottom-end",
                          delay: [600, 0],
                        },
                        expression:
                          "{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }",
                      },
                    ],
                    staticClass: "contact-information",
                    attrs: { content: _vm.getFullname() },
                  },
                  [
                    _vm.contact.vipCustomer
                      ? _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: {
                                  followCursor: true,
                                  placement: "bottom-end",
                                  delay: [600, 0],
                                },
                                expression:
                                  "{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }",
                              },
                            ],
                            staticClass: "material-icons vip",
                            attrs: { content: "★ VIP Customer" },
                          },
                          [
                            _vm._v(
                              "\n                        star\n                    "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.getFullname()) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.contact
                  ? _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "tippy",
                            rawName: "v-tippy",
                            value: {
                              followCursor: true,
                              placement: "bottom-end",
                            },
                            expression:
                              "{ followCursor: true, placement: 'bottom-end' }",
                          },
                        ],
                        staticClass: "contacted-date",
                        attrs: { content: _vm.getFullTime() },
                      },
                      [
                        _c(
                          "div",
                          { key: _vm.dateRenderKey, staticClass: "time-label" },
                          [
                            _vm.contactListSortMode.startsWith("chat.create") &&
                            !_vm.isClosedChat(_vm.contact)
                              ? _c("i", { staticClass: "material-icons" }, [
                                  _vm._v(
                                    "\n                            hourglass_top\n                        "
                                  ),
                                ])
                              : _c("i", { staticClass: "material-icons" }, [
                                  _vm._v(" watch_later "),
                                ]),
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.fromNow()) +
                                "\n                    "
                            ),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "contact-detail-content" }, [
                _c("div", { staticClass: "contact-detail-content-message" }, [
                  _c("div", { staticClass: "icon-wrapper" }, [
                    _vm.getMessageIcon()
                      ? _c("div", { staticClass: "material-icons" }, [
                          _vm._v(_vm._s(_vm.getMessageIcon())),
                        ])
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _vm.lastMessageIsAsset()
                    ? _c("div", { staticClass: "contact-last-message media" }, [
                        _vm._v(
                          "\n                        Media\n                        "
                        ),
                        _c("div", { staticClass: "material-icons" }, [
                          _vm._v("attach_file"),
                        ]),
                      ])
                    : _vm.lastMessageIsLocation()
                    ? _c("div", { staticClass: "contact-last-message media" }, [
                        _vm._v(
                          "\n                        Location\n                        "
                        ),
                        _c("div", { staticClass: "material-icons" }, [
                          _vm._v("location_on"),
                        ]),
                      ])
                    : _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                followCursor: true,
                                placement: "bottom-end",
                                delay: [600, 0],
                              },
                              expression:
                                "{ followCursor: true, placement: 'bottom-end', delay: [600, 0] }",
                            },
                          ],
                          staticClass: "contact-last-message",
                          class: {
                            "visitor-message": _vm
                              .getLastMessageSender()
                              .includes("visitor"),
                            "agent-message": _vm
                              .getLastMessageSender()
                              .includes("user"),
                          },
                          attrs: { content: _vm.getLastMessage() },
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.getLastMessage()) +
                              "\n                    "
                          ),
                        ]
                      ),
                ]),
                _vm._v(" "),
                _vm.getUnreadCount()
                  ? _c("div", { staticClass: "unread-badge" }, [
                      _vm._v(_vm._s(_vm.getUnreadCount())),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "chat-owner-text",
                  class:
                    ((_obj = {}),
                    (_obj[_vm.getChatOwnerStatus()] = true),
                    _obj),
                },
                [_c("div", [_vm._v(_vm._s(_vm.getChatOwnerText()))])]
              ),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }